// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.masterContainer > img {
    width: 100%;
    object-fit: cover;
    height: fit-content;
  }
  .masterContainer > div {
    width: 80%;
    margin: auto;
    padding: 60px 0 0 0;
  }

  .masterContainer > div:last-child {
padding: 20px 0;
  }

  .masterContainer > div > p {
    color: #000;
    margin-bottom: 20px;
    font-family: lightThicker !important ;
    font-size: clamp(16px, 4vw, 20px);
    font-weight: 400;
  }
  .bottom {
    width: 100% !important;
    padding: 50px 0px !important;
    background-color: #ba1e24;
    text-align: center;
  }
  .bottom > h1 {
    color: #fff;
    font-size: 54px;
    font-weight: 700;
  }
  .bottom > p {
    color: #fff !important;
    text-align: center;
    font-size: 20px;
    font-family: lightThicker !important;
  }
  .bottom > button {
    margin-top: 60px;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    padding: 20px;
    background: linear-gradient(0deg, #000 0%, #000 100%), #fff;
    border: none;
    cursor: pointer;
  }
  .table {
    border-collapse: collapse;
    margin-bottom: 30px;
    margin-top: 20px;
  }
  .table > tr > th {
    border: 1px solid #ba1e24;
    padding: 15px 40px;
    color: #ba1e24;
    font-size: 20px;
    width: 250px;
  }
  .table > tr > td {
    font-family: lightThicker !important ;
    border: 1px solid #ba1e24;
    padding: 15px 40px;
    font-size: 20px;
    width: 900px;
  }
  @media screen and (max-width: 600px) {
    .masterContainer > div {
      width: 90%;
      padding: 20px 0 0 0;
    }

    .masterContainer > div:last-child {
      padding: 10px 0 20px 0;
        }

    .table > tr > td {
        padding: 5px 10px;
        font-size: 16px;
      }
      .table > tr > th {
        padding: 5px 10px;
        font-size: 16px;
      }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/categories/master.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;;EAEA;AACF,eAAe;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,iCAAiC;IACjC,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,oCAAoC;EACtC;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,2DAA2D;IAC3D,YAAY;IACZ,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;EACd;EACA;IACE,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;EACA;IACE;MACE,UAAU;MACV,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;QACpB;;IAEJ;QACI,iBAAiB;QACjB,eAAe;MACjB;MACA;QACE,iBAAiB;QACjB,eAAe;MACjB;EACJ","sourcesContent":[".masterContainer > img {\n    width: 100%;\n    object-fit: cover;\n    height: fit-content;\n  }\n  .masterContainer > div {\n    width: 80%;\n    margin: auto;\n    padding: 60px 0 0 0;\n  }\n\n  .masterContainer > div:last-child {\npadding: 20px 0;\n  }\n\n  .masterContainer > div > p {\n    color: #000;\n    margin-bottom: 20px;\n    font-family: lightThicker !important ;\n    font-size: clamp(16px, 4vw, 20px);\n    font-weight: 400;\n  }\n  .bottom {\n    width: 100% !important;\n    padding: 50px 0px !important;\n    background-color: #ba1e24;\n    text-align: center;\n  }\n  .bottom > h1 {\n    color: #fff;\n    font-size: 54px;\n    font-weight: 700;\n  }\n  .bottom > p {\n    color: #fff !important;\n    text-align: center;\n    font-size: 20px;\n    font-family: lightThicker !important;\n  }\n  .bottom > button {\n    margin-top: 60px;\n    color: #fff;\n    font-size: 24px;\n    font-weight: 600;\n    padding: 20px;\n    background: linear-gradient(0deg, #000 0%, #000 100%), #fff;\n    border: none;\n    cursor: pointer;\n  }\n  .table {\n    border-collapse: collapse;\n    margin-bottom: 30px;\n    margin-top: 20px;\n  }\n  .table > tr > th {\n    border: 1px solid #ba1e24;\n    padding: 15px 40px;\n    color: #ba1e24;\n    font-size: 20px;\n    width: 250px;\n  }\n  .table > tr > td {\n    font-family: lightThicker !important ;\n    border: 1px solid #ba1e24;\n    padding: 15px 40px;\n    font-size: 20px;\n    width: 900px;\n  }\n  @media screen and (max-width: 600px) {\n    .masterContainer > div {\n      width: 90%;\n      padding: 20px 0 0 0;\n    }\n\n    .masterContainer > div:last-child {\n      padding: 10px 0 20px 0;\n        }\n\n    .table > tr > td {\n        padding: 5px 10px;\n        font-size: 16px;\n      }\n      .table > tr > th {\n        padding: 5px 10px;\n        font-size: 16px;\n      }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
